/**
 * useContentGroups
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import ContentGroupsContext from './content-groups-context'

const useContentGroups = () => {
  const context = useContext(ContentGroupsContext)
  return context
}

export default useContentGroups
